Auth = require 'db/auth'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'

module.exports = class SavedSearchView extends View
  className: 'saved-search'

  events:
    'click .js-delete-saved-search': 'deleteSavedSearch'
    'click .js-delete-saved-search-confirm': 'confirmDeletion'
    'click .js-delete-saved-search-cancel': 'cancelDeletion'

    'movesavedsearch': 'moveSavedSearch'

  render: ->
    data = @model.toJSON()
    data.allowDelete = Auth.me().isFeatureEnabled('savedSearches') || data.query != '@me'

    @$el.html(
      templates.fill(
        'saved_search',
        data
      )
    )

    @

  deleteSavedSearch: (e) ->
    @options.parent.closeAllDeleteMenus()
    @$('.js-saved-search-name').addClass('saved-search-item-faded')

    @$('.js-delete-saved-search').addClass('hide')
    @$('.js-delete-saved-search-menu')
    .removeClass('hide')

    @defer =>
      @$('.js-delete-saved-search-menu').addClass('saved-search-delete-menu-shown')

  confirmDeletion: (e) ->
    @model.destroy()

  cancelDeletion: (e) ->
    @$('.js-saved-search-name').removeClass('saved-search-item-faded')

    @$('.js-delete-saved-search').removeClass('hide')
    @$('.js-delete-saved-search-menu')
    .addClass('hide')
    .removeClass('saved-search-delete-menu-shown')

  moveSavedSearch: (e, ui) ->
    savedSearches = ui.item.parent().children()
    index = savedSearches.index(ui.item)
    @model.update('pos', Util.calcPos(index, Auth.me().savedSearchList, @model))
    @model.collection.sort({ silent: true })



// WEBPACK FOOTER //
// ./app/scripts/views/search/saved-search-view.coffee